// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"559a0ce9","283":"20a0f1ba","618":"3336a5f6","996":"4b3e6327"}[chunkId] + ".chunk.js";
};